export default { indicator: { height: 2 } };
